module.exports = __webpack_public_path__ + "media/assets/images/snow_later_will_sunny-86187a0ac93739f6675cf857f7e16cfc.png";